import React from 'react';
import { Star } from 'lucide-react';
import { testimonials, salonInfo } from '../data/mockData';

export const Testimonials = () => {
  return (
    <section className="section-padding bg-coconut">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="section-title mb-4">
            Was unsere Kunden sagen
          </h2>
          <p className="section-subtitle">
            Echte Bewertungen von zufriedenen Kunden
          </p>
          <div className="flex items-center justify-center mt-6 space-x-2">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-accent text-accent" />
              ))}
            </div>
            <span className="text-lg font-bold">{salonInfo.rating}</span>
            <span className="text-gray-600">• {salonInfo.reviewCount} Bewertungen</span>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              {/* Stars */}
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-accent text-accent" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-700 mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="border-t border-gray-200 pt-4">
                <div className="font-bold text-gray-900">
                  {testimonial.name}
                </div>
                <div className="text-sm text-gray-600">
                  {testimonial.service}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA to Treatwell */}
        <div className="text-center mt-12">
          <a 
            href={salonInfo.contact.treatwell}
            target="_blank"
            rel="noopener noreferrer"
            className="text-accent hover:text-accent-dark font-semibold inline-flex items-center group"
          >
            <span>Mehr Bewertungen auf Treatwell</span>
            <svg className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};
